import { Phone, MessageCircle } from 'lucide-react';

export const FloatingButtons = () => {
  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col space-y-3" data-testid="floating-buttons">
      {/* WhatsApp Button */}
      <a
        href="https://wa.me/9131709809"
        target="_blank"
        rel="noopener noreferrer"
        className="floating-btn w-14 h-14 bg-green-500 text-white rounded-full flex items-center justify-center shadow-lg hover:bg-green-600 hover:scale-110 transition-transform"
        data-testid="floating-whatsapp-btn"
        title="Chat on WhatsApp"
      >
        <MessageCircle className="h-6 w-6" />
      </a>

      {/* Call Button */}
      <a
        href="tel:7581061649"
        className="floating-btn w-14 h-14 bg-gradient-to-r from-brand-orange to-brand-rust text-white rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform"
        data-testid="floating-call-btn"
        title="Call Now"
      >
        <Phone className="h-6 w-6" />
      </a>
    </div>
  );
};
